<script setup lang="ts">
import type { PropType } from "vue";

defineProps({
  heading: {
    type: String as PropType<string>,
    required: true,
  },
});
</script>

<template>
  <div class="title-header">
    <div v-if="$slots.left" class="title-header--left">
      <slot name="left" />
    </div>

    <h1 class="title-header--heading">
      {{ heading }}
    </h1>

    <div v-if="$slots.right" class="title-header--right">
      <slot name="right" />
    </div>
  </div>
</template>

<style>
.title-header {
  display: grid;
  grid-template-columns: 1fr max-content 1fr;
  grid-template-areas: "left heading right";
  align-items: center;
  block-size: 100%;
  padding-block: var(--spacing-8);
}

.title-header--heading {
  @apply text-16/24;

  grid-area: heading;
  justify-self: center;
}

.title-header--left {
  grid-area: left;
  justify-self: start;
}

.title-header--right {
  grid-area: right;
  justify-self: end;
}
</style>
